export const styles = theme => ({
  defaultsCheckbox: {
    width: '17px',
    height: '16px',
    marginRight: '0.3vw',
    color: theme.palette.primary.main,
  },
  defaultsCheckBoxBlank: {
    fontSize: '24px',
    color: theme.palette.secondary.main,
  },
  defaultsCheckedIcon: {
    fontSize: '24px',
    color: theme.palette.primary.main,
  },
});